<template>
    <div class="mx-2 mx-sm-3 mx-lg-2">
        <div class="container case-container">
            <br />
            <br />
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-xl-8">
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <p class="text-center text-light mb-4">
                        <img src="/static/general/img/undraw_no_data.svg" height="170" />
                    </p>
                    <p class="h5 text-center mb-3 pt-2">You aren't assigned to any scenarios right now.</p>
                    <p class="text-center text-secondary">
                        If you're seeing this message after finishing a scenario, you can close this window.
                    </p>
                    <p class="text-center text-secondary">
                        <router-link :to="{name: 'LearnerHistory'}">View Learner History</router-link>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LearnerDefault",
}
</script>

<style>
</style>